import Model, { attr, belongsTo } from '@ember-data/model';
import type UserModel from './user.ts';
import type EmployeeModel from './employee.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class NotificationHistoryModel extends Model {
  @attr declare noteSubtype: string;
  @attr declare noteType: string;
  @attr declare createdAt: string;
  @attr declare toEmail: string;
  @attr declare fromEmail: string;
  @attr declare templateId: string;
  @attr declare templateSubstitutions: Record<string, string> | null;
  @attr declare noteSuccessful: boolean;
  @attr declare trackingToken: string;
  @attr declare firstOpenedAt: string;
  @attr declare openCount: number;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('user', { async: false, inverse: null })
  declare user: UserModel;
  @belongsTo('employee', { async: false, inverse: null })
  declare employee: EmployeeModel;

  [Type] = 'notification-history' as const;
}
